import { Vue } from "vue-property-decorator";
import _ from "lodash";

import { HttpService } from "@/core/services";
import { VueUserContextModel } from "@/core/models"; // Import the missing EvaluationLoginModel type

export const AccountService = new Vue({
  methods: {
    getVueUserContext() {
      return HttpService.getData<VueUserContextModel>(`account/context`);
    },
    isPrivacyPolicyAccepted() {
      return HttpService.getData<boolean>(`account/isPrivacyPolicyAccepted`);
    },
    acceptPrivacyPolicy() {
      return HttpService.put(`account/acceptPrivacyPolicy`);
    },
    hasStartedQuestionnaire() {
      return HttpService.getData<boolean>(`account/hasStartedQuestionnaire`);
    },
    startQuestionnaire() {
      return HttpService.put(`account/startQuestionnaire`);
    },
    isAttendanceRecorded() {
      return HttpService.getData<boolean>(`account/isAttendanceRecorded`);
    },
  },
});
